import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../../utils/components/CustomModal';

import Loader from '../../../assets/components/loader';

const PauseModal = ({
  changeModalState,
  onSave,
  loading,
}) => {

  return(
    <CustomModal
      footer={false}
      width={"750px"}
      modalTitle="Pause My Subscription"
      changeModalState={changeModalState}
      background="#EDF7FF"
      >
        <div className="pause--subscription--modal">
          <div className="text">
            <p>
              Sometimes, you just need a break.
              Pause your subcribtion and halt payment before next billing date.
            </p>
          </div>
          <div className="button">
          <button onClick={ev => onSave(ev)} className="custom--button custom--button--marquet">
            Pause subscription {loading && <Loader size="xs" />}
            </button>
          </div>
        </div>
    </CustomModal>
  )
}

export default PauseModal;